import { useQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";
import {
  GetTaskScheduleIds as GetTaskScheduleIdsGenerated,
  GetTaskScheduleIds_taskSchedulerConnections_places as GetTaskScheduleIdsPlaceGenerated,
  GetTaskScheduleIds_taskSchedulerConnections_places_relatedTasks as GetTaskScheduleIdsRelatedTaskGenerated,
  GetTaskScheduleIdsVariables as GetTaskScheduleIdsVariablesGenerated,
} from "core/queries/__generated__/GetTaskScheduleIds";

// GetTaskScheduleIds exports
export interface GetTaskScheduleIdsResponse
  extends GetTaskScheduleIdsGenerated {}
export interface GetTaskScheduleIdsVariables
  extends GetTaskScheduleIdsVariablesGenerated {}
export interface GetTaskScheduleIdsPlace
  extends GetTaskScheduleIdsPlaceGenerated {}
export interface GetTaskScheduleIdsRelatedTask
  extends GetTaskScheduleIdsRelatedTaskGenerated {}

// Queries
export const getTaskScheduleIds = gql`
  query GetTaskScheduleIds(
    $cursor: String = "0"
    $limit: Int = 100
    $filter: TaskSchedulerFilterInput!
  ) {
    taskSchedulerConnections(
      pagination: { cursor: $cursor, limit: $limit }
      filters: $filter
    ) {
      places {
        id
        relatedTasks {
          id
        }
      }
    }
  }
`;

export interface UseGetTaskScheduleIdsQueryOptions {
  notifyOnNetworkStatusChange?: boolean;
  pollInterval?: number;
  skip: boolean;
  variables: GetTaskScheduleIdsVariables;
}

export const useGetTaskScheduleIdsQuery = ({
  notifyOnNetworkStatusChange,
  pollInterval,
  skip,
  variables,
}: UseGetTaskScheduleIdsQueryOptions) =>
  useQuery<GetTaskScheduleIdsResponse, GetTaskScheduleIdsVariables>(
    getTaskScheduleIds,
    {
      fetchPolicy: "cache-and-network",
      notifyOnNetworkStatusChange,
      pollInterval,
      skip,
      variables,
    },
  );
